/** Les horaires de l'API sont déjà en heure de Paris ("2026-08-04 20:30:00") : on les lit tels quels. */
export const clockOf = (apiTime: string) => apiTime.slice(11, 16);

export function formatDay(isoDate: string, options: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat("fr-FR", options).format(new Date(`${isoDate}T12:00:00`));
}

export function formatDuration(minutes: number | null) {
  if (!minutes) return null;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0 ? `${hours} h` : `${hours} h ${String(rest).padStart(2, "0")}`;
}
